module.exports = "pegasus/assets/styleGroup3-google.png";